import { useEffect, useState } from "react";
import Pagination from "../../Components/Pagination";
import { University_WebsiteDetails_Table } from "../../Models/universityWebDetailsModel";
import UniversityWebTableRow from "./UniversityWebTableRow";

function UniversityWebDetailsTable({
  UniversityWebDetailsList,
  LOADING,
  University_Web_Details_Get_Req,
  handleDeleteUniversityWebDetails,
  handleEditUniversityWebDetails,
  setUniversityWebDetailsList,
}) {
  const [WebDetailsPaginationTable, setWebDetailspaginationTable] = useState(
    UniversityWebDetailsList
  );

  const [Page_data, setPage_data] = useState(10);

  const UniversityWebDetailsTable_Set = (page = 10) => {
    let New_data = [];
    for (let i = 0; i < UniversityWebDetailsList?.length; i++) {
      New_data.push(UniversityWebDetailsList[i]);
      if (i === page - 1) {
        break;
      }
    }
    setWebDetailspaginationTable(New_data);
    setPage_data(page);
  };

  const SetPaginate_Page = (page) => {
    let New_data = [];
    for (
      let i = Page_data * (page - 1);
      i < UniversityWebDetailsList?.length;
      i++
    ) {
      New_data.push(UniversityWebDetailsList[i]);
      if (New_data?.length === Page_data) {
        break;
      }
    }
    setWebDetailspaginationTable(New_data);
  };

  useEffect(() => {
    UniversityWebDetailsTable_Set();
  }, [LOADING, UniversityWebDetailsList]);

  return (
    <div className="col-md-9 col-lg-10">
      <div className="coctacts-table">
        <div className="table-responsive custom-scroll-right-bottum">
          <table className="table table-condensed ">
            <thead className="t-head-th-bg">
              <tr>
                {University_WebsiteDetails_Table?.map((el, i) => (
                  <th className="t-head-fixed" key={i}>
                    {el}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="table-bordered">
              {WebDetailsPaginationTable?.map((el) => (
                <UniversityWebTableRow
                  key={el.Id}
                  {...el}
                  setUniversityWebDetailsList={setUniversityWebDetailsList}
                  University_Web_Details_Get_Req={
                    University_Web_Details_Get_Req
                  }
                  handleEditUniversityWebDetails={
                    handleEditUniversityWebDetails
                  }
                  handleDeleteUniversityWebDetails={
                    handleDeleteUniversityWebDetails
                  }
                />
              ))}
            </tbody>
          </table>
        </div>
        <div className="Pagination">
          <Pagination
            SetPaginate_Page={SetPaginate_Page}
            PaginationTable={Page_data}
            UniversityTable_Set={UniversityWebDetailsTable_Set}
            Total_Records={UniversityWebDetailsList?.length}
          />
        </div>
      </div>
    </div>
  );
}

export default UniversityWebDetailsTable;
